import { ReactNode } from "react";
import { usePageTransition } from "~/lib/usePageTransition";
import { cn } from "~/lib/utils";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export function PageTransition({ children, className, delay = 0 }: PageTransitionProps) {
  const { isVisible, isExiting } = usePageTransition();

  return (
    <div
      className={cn(
        "transition-all duration-300 ease-out",
        // Initial hidden state - before animation starts
        !isVisible && !isExiting && "translate-y-2 opacity-0",
        // Animate in
        isVisible && !isExiting && "animate-in fade-in-0 slide-in-from-bottom-2",
        // Animate out
        isExiting && "animate-out fade-out-0 slide-out-to-bottom-2",
        className,
      )}
      style={{
        animationDelay: `${delay}ms`,
        animationFillMode: "both",
      }}
    >
      {children}
    </div>
  );
}
